export function formatToMinutesSeconds(position) {
  const seconds = (`0${  Math.floor(position % 60)}`).slice(-2)
  const minutes = (`0${  Math.floor((position / 60) % 60)}`).slice(-2)
  // let hours = ('0' + Math.floor((position / 3600) % 24)).slice(-2)
  return `${minutes}:${seconds}`
}

export function formatToSeconds(string) {
  const minutesToSeconds = string.split(':')
  const minutes = Number(minutesToSeconds[0]) * 60
  const seconds = Number(minutesToSeconds[1])
  return minutes + seconds
}

export function formatTimeDifference(timestamp) {
  const today = new Date()
  const date = new Date(timestamp)
  return String(date)
  const seconds = today.getSeconds() - date.getSeconds()
  if (seconds < 60) return `hace ${seconds} segundos`
  const minutes = today.getMinutes() - date.getMinutes()
  if (minutes < 60) return `hace ${minutes} minutos`
  const hours = today.getHours() - date.getHours()
  if (hours < 24) return `hace ${hours} horas`
}
